import { RoomStateEvent, Room, RoomMember, MatrixEvent, MatrixClient } from 'matrix-js-sdk';
import { matrixClient } from '../../client';
import { Log } from '@fanfanlo';
import { matrixRoom } from '../../room';
import { RoomMembership } from '../types';


const fileLogger = new Log(false, 'im.client.room.handlers.roomMember');
fileLogger.childrenPaused = true;
function onRoomMember(event: MatrixEvent, state: any, member: RoomMember) {
    const logger = fileLogger.sub(false, 'onRoomMember_fn');
    // logger.pause = true;
    const roomId = member.roomId;
    if (!roomId) return;

    const room = matrixClient.client.getRoom(roomId);
    if (!room) return;

    logger.log(`Member update in room ${room.name} (${room.roomId}):`);
    logger.log(`  User: ${member.userId}, Membership: ${member.membership}`);

    // 设置加载状态
    matrixRoom.roomData.isFetchingMembers.value = true;

    // 更新房间成员列表
    const currentMembers = matrixRoom.roomData.roomMembers[roomId] || [];
    const newMembers = [...currentMembers];
    
    // 更新现有成员
    const memberIndex = newMembers.findIndex(m => m.userId === member.userId);
    if (memberIndex !== -1) {
        newMembers[memberIndex] = {
            userId: member.userId || '',
            displayName: member.name || '',
            avatarUrl: member.getAvatarUrl() || '',
            membership: member.membership as RoomMembership
        };
    } else {
        // 添加新成员
        newMembers.push({
            userId: member.userId || '',
            displayName: member.name || '',
            avatarUrl: member.getAvatarUrl() || '',
            membership: member.membership as RoomMembership
        });
    }

    // 触发更新
    matrixRoom.roomData.roomMembers[roomId] = newMembers;
    matrixRoom.roomData.isFetchingMembers.value = false;
}

export const roomMemberHandler = {
    init() {
       
        matrixClient.clientOnEventDispatcher.addListener(RoomStateEvent.NewMember, onRoomMember);
        matrixClient.clientOnEventDispatcher.addListener(RoomStateEvent.Members, onRoomMember);
    }
};
